import ajax from '@/plugin/ajax'
import * as blessing from '@/data/blessing'

const getBlessing = function () {
    return blessing[Math.floor(Math.random() * blessing.length)]
}

const getAdBanner = function () {
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/ad_webapi/vipad').then(res => {
            if (res.status === 200) {
                resolve(res.data.homepage)
            } else {
                reject(res.status)
            }
        })
    })
}

const getBaseSet = function () {
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/baseSet').then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const getUserInfo = function () {
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/user/newdata/').then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const getWeather = function (postcode) {
    let query = {
        type: 4
    }
    if(postcode) {
        query.cityCode = postcode
    }
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/weather', {
            params: query
        }).then(res => {
            if (res.status === 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const logout = function () {
    return new Promise((resolve, reject) => {
        ajax.post('/lg/login/out').then(res => {
            if (res.status == 200) {
                resolve(true)
            } else {
                reject()
            }
        })
    })
}
export const getSendMessageType =function(){
    return new Promise((resolve, reject) => {
        ajax.get('/vipapi/anoy/messageOp/getType').then(res => {
            if (res.status == 200) {
                resolve(res.data)
            } else {
                reject(res.status)
            }
        })
    }) 
}


export {
    getBlessing,
    getAdBanner,
    getBaseSet,
    getUserInfo,
    getWeather,
    logout,
}



// WEBPACK FOOTER //
// ./src/service/homeService.js